import React from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Grid } from '@material-ui/core';
import { LayoutPageGrid } from '../../../../ui/LayoutGrid';
import { Loading } from '../../../../ui/Loading';
import { useSeasonViewQuery } from '../../../../schema';
import { SeasonInfoCard, PrizesList, QuestsList } from './components';

export const SeasonViewPage = () => {
  const { seasonId } = useParams<{ seasonId: string }>();
  const { data, loading, error } = useSeasonViewQuery({
    variables: { id: seasonId },
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    toast.error('Ошибка загрузки сезона');
    return null;
  }

  const seasonTitle = data?.season?.generalInformation.title || 'Сезон';

  return (
    <LayoutPageGrid title={seasonTitle}>
      <SeasonInfoCard data={data} />

      <Grid container spacing={2} style={{ marginLeft: 16 }}>
        <Grid item>
          <PrizesList data={data} seasonId={seasonId} />
        </Grid>
        <Grid item>
          <QuestsList data={data} seasonId={seasonId} />
        </Grid>
      </Grid>
    </LayoutPageGrid>
  );
};
